export default __webpack_public_path__ + "static/Image_4-5a433fd054e3cf2d85a35675ddb5838e.jpg";